import { z } from 'zod';
import { getApiInstance, harden, Response } from '../core';
import { Cache } from '../cache';

const activeAlertSchema = z.object({
    identifier: z.string().nullable(),
    title: z.string(),
    description: z.string(),
    instruction: z.string().nullable(),
    effectiveDate: z.string(),
    onset: z.string(),
    sent: z.string(),
});

export const playerApiAlertFeedResponseShapeValidator = z.object({
    status: z.literal('OK'),
    message: z.object({
        code: z.literal('NO_ERROR'),
    }),
    alerts: z.array(activeAlertSchema),
});

export async function getAlertConfigurationAlerts(
    configId: number
): Response<z.infer<typeof playerApiAlertFeedResponseShapeValidator>> {
    const { api, cacheConfig } = await getApiInstance();
    const urlPath = `alert-configuration/${encodeURIComponent(configId)}/alerts`;

    cacheConfig(Cache.GetWithFallback, urlPath);

    const response = await api.get(urlPath);

    return harden(playerApiAlertFeedResponseShapeValidator, response.data);
}
